module.exports = __webpack_public_path__ + "static/media/number-one.eec1f5d3.svg";